import React from 'react';
import PackagesMegaMenu from './PackagesMegaMenu';
import AboutUsMegaMenu from './AboutUsMegaMenu';

/**
 * MegaMenuManager - Manages the display of mega menus
 * 
 * This component handles which mega menu to display based on the active menu
 */
const MegaMenuManager = ({
  activeMenu,
  onClose,
  openComparisonModal = null,
  openRecommendationModal = null,
  openWirelessAdvisorModal = null,
  openRouterFeaturesModal = null,
  openISPFeaturesModal = null,
  openCoverageSidebar = null
}) => {
  // Render the appropriate mega menu based on the active menu
  return (
    <>
      <PackagesMegaMenu
        isOpen={activeMenu === 'packages'}
        onClose={onClose}
        openComparisonModal={openComparisonModal}
        openRecommendationModal={openRecommendationModal}
        openWirelessAdvisorModal={openWirelessAdvisorModal}
        openCoverageSidebar={openCoverageSidebar}
      />
      <AboutUsMegaMenu
        isOpen={activeMenu === 'about'}
        onClose={onClose}
        openRouterFeaturesModal={openRouterFeaturesModal}
        openISPFeaturesModal={openISPFeaturesModal}
      />
    </>
  );
};

export default MegaMenuManager;